// extracted by mini-css-extract-plugin
export var avatarContainer = "_ce-0";
export var avatarTypingWave = "_ce-i";
export var gray = "_ce-f";
export var green = "_ce-c";
export var icon = "_ce-9";
export var image = "_ce-1";
export var lg = "_ce-6";
export var md = "_ce-5";
export var presenceDot = "_ce-b";
export var red = "_ce-d";
export var sm = "_ce-4";
export var status = "_ce-a";
export var typingDot = "_ce-h";
export var typingPill = "_ce-g";
export var xl = "_ce-7";
export var xs = "_ce-3";
export var xxl = "_ce-8";
export var xxs = "_ce-2";
export var yellow = "_ce-e";